// @ts-nocheck
/* eslint-disable */
'use strict';

import Utils from '@/utils/QSUtils';
import IWorkingUADParams from '@/models/uad/IWorkingUADParams';
import { SourceDataInitials } from '@/constants/SourceDataInitials';
import ISourceData from '@/models/comp/ISourceData';

export default {
    async parser(params: IWorkingUADParams): ISourceData {
        let sourceData: ISourceData = {};

        //QSRC-722 need to clear condo-specific fields from MLS import if form is sfr, and vice versa
        if (params.sourceInitial === SourceDataInitials.Mls) {
            params.sourceData = this.updateMlsValuesForForm(params.formCode, params.sourceData);
        }

        params.parser.ParserActive = false;

        // Set UAD fields
        for (const field in params.sourceData) {
            // QSRC-313 need to filter out nulls
            if (params.sourceData[field] != null) {
                params.parser[field] = params.sourceData[field];
            }
        }

        params.parser.ParserActive = true;

        // Checking if SE and NOT Opted In to SE then parse static data as BuildTriggerFields
        if (params.sourceInitial === SourceDataInitials.PublicRecords || params.sourceInitial === SourceDataInitials.Mls || (params.sourceInitial === SourceDataInitials.SmartExchange && !params.isSEOptedIn)) {
            params.parser.BuildTriggerFields();
        } else {
            params.parser.ParseTriggerFields();
        }

        // TODO: We should not have to do the below two for loops.  For some reason the field name without a starting underscore
        // is not getting resolved on before accessing the value.  So below we are accessing the private field names value and also
        // accessing the non UAD field names (ie. MARKETAREA).
        // The below commented out code is from the v1 QS.  This should be all that we need to do....
        // for (const field in params.parser) {
        //     if (Utils.isUpperCase(field) && field.substring(1, 0) !== "_") {
        //         sourceData[field] = params.parser[field];
        //     }
        // }

        // Gatter all fields with a starting "_"
        for (const field in params.parser) {
            if (Utils.isUpperCase(field) && field.substring(1, 0) === '_') {
                const fieldName = field.replace(/^_/, '');
                sourceData[fieldName] = params.parser[field];
            }
        }

        // Gatter all remaining fields without "_"
        for (const field in params.parser) {
            if (Utils.isUpperCase(field) && field.substring(1, 0) !== '_') {
                if (!Utils.isKeyInObject(sourceData, field) && params.parser[field]) {
                    sourceData[field] = params.parser[field];
                }
            }
        }

        return sourceData;
    },
    updateMlsValuesForForm(formCode: string, sourceData: any) {
        let condoFields = ['NUMLEVELS', 'PT_DETACH', 'PT_GARDEN', 'PT_HIRISE', 'PT_MIDRISE', 'PT_ROWTOWN', 'PT_OTHER', 'EX_GARPRK', 'EX_COVPRK', 'EX_OPENPRK', 'AB_GARPRK'];
        let sfrFields = ['NUMSTORIES', 'TP_DETACH', 'TP_SEMIDET', 'TP_ATTACH', 'EX_GARATT', 'EX_DRVWY', 'EX_GARDET', 'EX_GARBLT', 'EX_CARPT'];

        //Non UAD formCodes are coming in as Numbers causing 'includes' method to fail.
        formCode = formCode.toString();

        // remove condo fields for single family residence forms
        if (formCode.includes('1004') || formCode.includes('2055')) {
            for (var i = 0; i < condoFields.length; i++) {
                if (Utils.isKeyInObject(sourceData, condoFields[i])) {
                    delete sourceData[condoFields[i]];
                }
            }
        }

        // remove single family residence form fields for condo forms
        if (formCode.includes('1073') || formCode.includes('1075')) {
            for (var i = 0; i < sfrFields.length; i++) {
                if (Utils.isKeyInObject(sourceData, sfrFields[i])) {
                    delete sourceData[sfrFields[i]];
                }
            }
        }

        return sourceData;
    },
};
